/**
 * Weekly step navigator — `‹ {This/Next/Week of…} week ›`. Same prev/label/
 * next shape as the Chefs date stepper, weekly-only (no Daily toggle).
 */

import { ChevronLeft, ChevronRight } from 'lucide-react'
import type { ReactElement } from 'react'

import { addDaysKey, todayKey, weekNavLabel } from '@/lib/school-orders/calendar'

export interface WeekNavProps {
  /** Monday key of the selected week. */
  anchorKey: string
  onAnchorChange: (mondayKey: string) => void
}

export function WeekNav({ anchorKey, onAnchorChange }: WeekNavProps): ReactElement {
  const label = weekNavLabel(anchorKey, todayKey())
  return (
    <div className="flex items-center gap-1">
      <button
        type="button"
        aria-label="Previous week"
        onClick={() => onAnchorChange(addDaysKey(anchorKey, -7))}
        className="inline-flex h-8 w-8 items-center justify-center rounded-full text-muted-foreground transition-colors hover:bg-muted/50">
        <ChevronLeft className="h-5 w-5" strokeWidth={1.75} />
      </button>
      <span className="min-w-[7rem] px-1 text-center text-base font-semibold text-foreground">{label}</span>
      <button
        type="button"
        aria-label="Next week"
        onClick={() => onAnchorChange(addDaysKey(anchorKey, 7))}
        className="inline-flex h-8 w-8 items-center justify-center rounded-full text-muted-foreground transition-colors hover:bg-muted/50">
        <ChevronRight className="h-5 w-5" strokeWidth={1.75} />
      </button>
    </div>
  )
}
